import { onMounted, onBeforeUnmount } from "vue";

/**
 * Закрывает выпадающий список при клике вне переданного триггера и вне .dropdown
 */
export function useClickOutsideDropdown(triggerRef, callback) {
    const handler = event => {
        const clicked = event.target;

        // 1) Если внутри кнопки-триггера — не закрываем
        const trigEl = triggerRef.value;
        if (trigEl && typeof trigEl.contains === "function" &&
            (trigEl === clicked || trigEl.contains(clicked))) {
            return;
        }

        // 2) Если внутри dropdown (.dropdown) — не закрываем
        if (event.composedPath().some(el => el instanceof Element && el.classList?.contains("dropdown"))) {
            return;
        }


        // иначе — клик вне, закрываем
        callback(event);
    };

    onMounted(() => document.addEventListener("click", handler));
    onBeforeUnmount(() => document.removeEventListener("click", handler));
}